/**
 * Sknny Chef — Conversion Tracking
 * Tracks: join_community_click, video_play, scroll_depth, exit_intent_shown, community_form_submit
 */
(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────────── */

  function sendGtagEvent(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params || {});
    }
  }

  function sendFbqEvent(eventName, params) {
    if (typeof fbq === 'function') {
      fbq('track', eventName, params || {});
    }
  }

  /* ── 1. Join Community Click ───────────────────────────────── */

  function trackJoinCommunityClicks() {
    document.addEventListener('click', function (e) {
      var target = e.target.closest('.btn-join-community, [data-track="join"]');
      if (!target) return;

      sendGtagEvent('join_community_click', {
        event_category: 'engagement',
        event_label: target.textContent.trim().substring(0, 100)
      });
      sendFbqEvent('Lead', {
        content_name: 'Join Community Click'
      });
    });
  }

  /* ── 2. Video Play (YouTube iframe postMessage) ────────────── */

  function trackVideoPlay() {
    var videoPlayed = false;

    window.addEventListener('message', function (e) {
      if (videoPlayed) return;

      // YouTube iframe API sends JSON messages
      var data;
      try {
        data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
      } catch (_) {
        return;
      }

      // YouTube PlayerState.PLAYING === 1
      if (
        data &&
        data.event === 'onStateChange' &&
        data.info === 1
      ) {
        videoPlayed = true;
        sendGtagEvent('video_play', {
          event_category: 'engagement',
          event_label: 'youtube_embed'
        });
      }
    });

    // Enable JS API on existing YouTube iframes so they send postMessages
    var iframes = document.querySelectorAll('iframe[src*="youtube.com"]');
    iframes.forEach(function (iframe) {
      var src = iframe.src;
      if (src.indexOf('enablejsapi') === -1) {
        iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1';
      }
    });
  }

  /* ── 3. Scroll Depth ───────────────────────────────────────── */

  function trackScrollDepth() {
    var firedThresholds = new Set();
    var thresholds = [25, 50, 75, 100];

    function getScrollPercent() {
      var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (docHeight === 0) return 100;
      return Math.round((window.scrollY / docHeight) * 100);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var pct = getScrollPercent();
        thresholds.forEach(function (threshold) {
          if (pct >= threshold && !firedThresholds.has(threshold)) {
            firedThresholds.add(threshold);
            sendGtagEvent('scroll_depth', {
              event_category: 'engagement',
              event_label: threshold + '%',
              value: threshold
            });
          }
        });
        ticking = false;
      });
    });
  }

  /* ── 4. Exit Intent Shown ──────────────────────────────────── */

  function trackExitIntent() {
    document.addEventListener('exitIntentShown', function () {
      sendGtagEvent('exit_intent_shown', {
        event_category: 'engagement',
        event_label: 'exit_intent_popup'
      });
    });
  }

  /* ── 5. Community Form Submit ──────────────────────────────── */

  function trackCommunityFormSubmit() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-form="community"]');
      if (!form) return;

      sendGtagEvent('community_form_submit', {
        event_category: 'conversion',
        event_label: 'community_signup'
      });
      sendFbqEvent('CompleteRegistration', {
        content_name: 'Community Form Submit'
      });
    });
  }

  /* ── Init ───────────────────────────────────────────────────── */

  function init() {
    trackJoinCommunityClicks();
    trackVideoPlay();
    trackScrollDepth();
    trackExitIntent();
    trackCommunityFormSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
